import { assertNever } from '@/helpers/utils';
import { Area, AreaLoadHandlingType } from '@/modules/floorplanDesign/types';
import { ManualArea, RackingArea, SingularStationArea } from '@thive/fddm-types';

export type LoadHandlingArea = SingularStationArea | RackingArea | ManualArea;

/**
 * Type guard for areas that carry a load handling type
 * (`SingularStationArea`, `ManualArea`, `RackingArea`).
 * Returns `false` for areas that don't (highway, stationary).
 */
export const isLoadHandlingArea = (area: Area): area is LoadHandlingArea => {
  switch (area.areaType) {
    case 'SINGULAR':
    case 'MANUAL':
    case 'RACKING':
      return true;
    case 'HIGHWAY':
    case 'STATIONARY':
      return false;
    default:
      return assertNever(area);
  }
};

/**
 * Returns the load handling type for any area that has one
 * (`SingularStationArea.loadHandlingType`, `ManualArea.loadHandlingType`,
 * `RackingArea.rackingLoadHandlingType`), or `null` for area types that
 * don't carry one (highway, stationary).
 */
export const getAreaLoadHandlingType = (area: LoadHandlingArea): AreaLoadHandlingType => {
  switch (area.areaType) {
    case 'SINGULAR':
    case 'MANUAL':
      return area.loadHandlingType;
    case 'RACKING':
      return area.rackingLoadHandlingType;
    default:
      return assertNever(area);
  }
};
